import React, { useState, useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import ScratchedLink from 'shared/scratched-nav-item';
import Container from 'container';
import axios from 'axios';
import Img from 'img';
import Headline from 'headline';
import Icon from 'icon';
import Button from 'button';
import Input from 'shared/form-input';
import featuredInfluencerPosts from 'data/featured-influencers-posts.json';
import { useFormInput, useErrors, useSubmitReady } from 'hooks/useForm';
import helpers from 'utils/helpers';
import data, { exceptions, hasException } from '@/layout/data';

import s from './footer.module.scss';

export default function Footer({ article, ...props }) {
  const { pages, social } = data;
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [areColumnsVisible, setColumnsVisible] = useState(true);

  const buttonContent = () => {
    if (loading) {
      return (
        <span className={s.spinner}>
          <Icon icon="spinner" className="animate-spin" />
        </span>
      );
    }
    if (success) return 'Success!';
    return 'Submit';
  };

  const email = useFormInput('');
  const emailErrors = useErrors({ email: email.state });
  const submitReady = useSubmitReady({
    email: email.state
  });

  const resetForm = () => {
    email.setters.setBlurred(false);
    email.setters.setTouched(false);
    email.setters.setValue('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      email: email.state.value,
      page: window.location.pathname,
      date: new Date().toDateString()
    };
    try {
      const res = await axios.post(
        'https://furlough-main.firebaseio.com/newsletter.json',
        payload
      );
      setLoading(false);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 5000);
      console.log(res);
    } catch (error) {
      console.log('error', error);
    }
    resetForm();
  };

  useEffect(() => {
    if (hasException(exceptions)) {
      setColumnsVisible(false);
    }
  }, []);
  return (
    <Container className={s.footer} as="footer">
      <div className={s.wrapper}>
        <div className={s.block}>
          <div className={s.logoWrapper}>
            <Icon className={s.logo} icon="furlough-logo" />
          </div>
          <div className={`${s.text} ${s.logoText}`}>
            Providing transparency to influencers, brands, and fans using
            data-driven audience insights along with strategic curated
            campaigns.
          </div>
          <Link className={s.staticLink} to="/about-us/">
            About
          </Link>
        </div>
        {
          areColumnsVisible ? (
            <>
              <ul className={`${s.block} ${s.navigationWrapper}`}>
                <Headline className={s.title} h5="true" white>
                  Navigation
                </Headline>
                {pages.map(({ text, href }) => (
                  <li key={`footer-${text}`} className={s.navigation}>
                    <ScratchedLink {...{ category: text, href }} />
                  </li>
                ))}
              </ul>
              <ul className={`${s.block} ${s.posts}`}>
                <Headline className={s.title} h5="true" white>
                  Featured Influencers
                </Headline>
                {featuredInfluencerPosts.map(
                  ({ title, date, featuredImage, slug }) => {
                    const dateString = helpers.getDateString(date);
                    return (
                      <li key={title} className={s.postCard}>
                        <div
                          className={s.imgWrapper}
                          onClick={() => navigate(`/${slug}`)}
                        >
                          <Img
                            effect
                            className={s.img}
                            src={featuredImage}
                            alt={featuredImage?.title}
                          />
                        </div>
                        <div className={s.textWrapper}>
                          <Headline h5="true" white className={s.postTitle}>
                            <Link to={`/${slug}`}>{title}</Link>
                          </Headline>
                          <Icon icon="clock" />
                          <span>{dateString}</span>
                        </div>
                      </li>
                    );
                  }
                )}
              </ul>
            </>
          )
            :
            ''
        }
        <div className={s.block}>
          <Headline className={s.title} h6="true" white>
            Featured Posts
          </Headline>
          <p className={s.text}>Sign up and stay up to date</p>
          <form onSubmit={handleSubmit}>
            <Input
              required
              transparent="true"
              type="text"
              name="email"
              placeholder="Email"
              {...email.events}
              error={emailErrors.email}
              value={email.state.value}
              className={s.input}
              lowOpacity
            />
            <Button
              className={s.button}
              primary="true"
              type="submit"
              disabled={!submitReady}
            >
              {buttonContent()}
            </Button>
            {success && (
              <p
                dangerouslySetInnerHTML={{
                  __html: `Thank you for signing up!
`
                }}
              />
            )}
            <a
              className={s.cxnLink}
              href="https://cxncollective.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              Powered by CXN Agency
            </a>
          </form>
        </div>
      </div>
      {/* <div className={s.bottomContent}>
        <p>Copyright © 2019 Furlough. All rights reserved.</p>
        <div className={s.links}>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
          <span>|</span>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div> */}
    </Container>
  );
}
